// Publications data for the Publications page
export const publicationsList = [
  {
    title: "Adaptive PID Control for Quadrotor UAVs Using Feedback Linearization and Deep Reinforcement Learning",
    status: "Accepted",
    statusColor: "orange",
    year: "2026",
    authors: "Shreehan Santosh Kate, T. Shuprajhaa, K. Srinivasan",
    venue: "IEEE North-East India International Energy Conversion Conference and Exhibition (NEIECCE) 2026"
  },
  {
    title: "Deep Reinforcement Learning Framework for Adaptive Control of Swing-up Inverted Pendulum",
    status: "Accepted",
    statusColor: "yellow",
    year: "2025",
    authors: "Shreehan Santosh Kate, T. Shuprajhaa, K. Srinivasan",
    venue: "5th International Conference on Emerging Electronics and Automation",
    link: "https://drive.google.com/drive/u/1/folders/1yU5gb-d-D4MZdCXlzVD_Qjbz4Jb59mCc"
  },
  {
    title: "Bio-Inspired Optimization of LQR Controllers for Feedback-Linearized Cruise Missiles",
    status: "Published",
    statusColor: "green",
    year: "2024",
    authors: "Chitta Subbareddy, Ramakalyan Ayyagari, Shreehan Santosh Kate",
    venue: "9th International Conference on Inventive Systems and Control (ICISC)",
    link: "https://ieeexplore.ieee.org/document/11188300"
  }
];
